/* eslint-disable regexp/no-unused-capturing-group */
import Color from '@tiptap/extension-color'
import Link from '@tiptap/extension-link'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'
import { generateHTML } from '@tiptap/vue-3'
import FontSize from 'tiptap-extension-font-size'
import ImageResize from 'tiptap-extension-resize-image'

import { parseEditorContent } from './parseEditorContent'

export const parseHTMLFromEditor = (content: string | undefined, disableFormatting?: boolean) => {
  const parsed = parseEditorContent(content)
  if (!parsed) {
    return ''
  }
  if (typeof parsed === 'string') {
    return parsed
  }

  const html = generateHTML(parsed, [
    StarterKit,
    TextStyle,
    FontSize,
    Color,
    Underline,
    Link.configure({
      openOnClick: false,
      autolink: false,
    }),
    ImageResize.configure({
      inline: false,
      allowBase64: false,
      HTMLAttributes: {},
    }),

    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
  ])
  if (disableFormatting) {
    return html.replace(/(<([^>]+)>)/g, '')
  }

  return html
}
